import { TextField } from "@mui/material";
import React, { Suspense, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import {
    submitMigrationAction,
} from "../../Action/user.action";
import Dashboardheader from "../../directives/dashboardheader";
import toast from "react-hot-toast";
import { Link, useLocation, useNavigate } from "react-router-dom";
import config from "../../config/config";
import { useSelector } from "react-redux";
import { IoIosArrowRoundBack } from "react-icons/io";

const MigrationContent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = location.state || {};   // getting id from state
    const balance = useSelector((state) => state.migrationAmountData.migrationData);

    const [isChecked, setIsChecked] = useState(false);

    const MigrateAmount = async () => {
        if (!isChecked) {
            toast.error("Please accept the Terms & Conditions before proceeding.");
            return;
        }
        try {
            const data = { wallet_id: id };
            const res = await submitMigrationAction(data);
            if (res.success) {
                toast.success(res.msg);
                navigate(-1);
            } else {
                toast.error(res.msg || "Migration failed");
            }
        } catch (error) {
            console.log(error);
            toast.error("Something went wrong!");
        }
    };

    const handleBackNavigation = () => {
        navigate(-1);
    };

    return (
        <>
            <Dashboardheader />
            <div className="position-relative">
                <Container className="px-sm-5 px-2 mb-5 text-white mt-5">
                    <div
                        onClick={handleBackNavigation}
                        style={{ cursor: "pointer" }}
                        className="d-flex gap-2 align-items-center text-white mb-3"
                    >
                        <p className="mb-0 d-flex align-items-center">
                            <IoIosArrowRoundBack size={25} /> Back
                        </p>
                    </div>

                    <div className="card card-view rounded-20 border-0">
                        <div className="card-body">
                            <Row>
                                <Col lg={6} className="px-sm-5 px-2 py-3">
                                    <div className="withdraw_form2">
                                        <div className="text-center pb-1">
                                            <h3 className="sofia-sans fw-semibold">Migration Token</h3>
                                        </div>
                                        <div className="text-center sofia-sans mb-4 pb-1">
                                            Balance :&nbsp;
                                            <span id="web13Balance">
                                                {id === 3 ? balance?.step_balance : balance?.referral_balance} MNT
                                            </span>
                                        </div>

                                        <div className="mxbtn position-relative">
                                            <TextField
                                                label="Amount"
                                                 id="outlined-password-input"
                                                type="text"
                                                value={id === 3 ? balance?.step_balance : balance?.referral_balance}
                                                // fullWidth
                                                autoComplete="off"
                                                placeholder="Enter Amount"
                                                InputLabelProps={{ shrink: true }}
                                                style={{color: "white", width: "100%"}}
                                            />
                                        </div>
                                        <br />
                                        <div className="d-flex gap-2 mb-3 align-items-center">
                                            <input
                                                className="custom-checkbox mt-1"
                                                style={{ width: 15, height: 15 }}
                                                type="checkbox"
                                                checked={isChecked}
                                                onChange={(e) => setIsChecked(e.target.checked)}
                                            />
                                            <div className="d-flex gap-1 sofia-sans">
                                                <p className="mb-0">I Agree with the</p>
                                                <Link
                                                    target="_blank"
                                                    className="tnc"
                                                    to={`${config.baseUrl}signuptermsandconditions`}
                                                >
                                                    Terms & Conditions
                                                </Link>
                                            </div>
                                        </div>

                                        <Button
                                            variant="main2"
                                            className="w-100 mb-3"
                                            onClick={MigrateAmount}
                                        // disabled={!isChecked} // ✅ Disable button until checked
                                        >
                                            Migrate Now
                                        </Button>
                                    </div>
                                </Col>

                                {/* RIGHT SIDE TERMS */}
                                <Col lg={6} className="mt-3">
                                    <p
                                        style={{ fontSize: "14px", marginTop: "2.5px" }}
                                        dangerouslySetInnerHTML={{ __html: balance?.terms }}
                                    ></p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

// ✅ Wrap in Suspense for React 18
export default function Migration() {
    return (
        <Suspense fallback={<div className="text-center mt-5">Loading migration data...</div>}>
            <MigrationContent />
        </Suspense>
    );
}
